<template>
    <div>
    </div>
</template>

<script>
    export default {
        name: "Steps",
        props:['etapa'],
        data() {
            return {
                
            }
        },
        methods: {
        },
        computed: {
            titulo: function(){
                return this.$store.state.contratar.titulo
            }
        },
    }
</script>

<style lang="scss" scoped>
.card-header{
  h4{
    color:#fff;
    text-align: center;
  }
}

</style>